import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const watchTimeApi = createApi({
  reducerPath: 'watchTimeApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['WatchTime'],
  endpoints: (builder) => ({
    getMyWatchStats: builder.query({
      query: () => '/watch-time/me',
      providesTags: ['WatchTime'],
    }),
  }),
});

export const { useGetMyWatchStatsQuery } = watchTimeApi;
